import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './ui/Logo';
export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const goTo = (path: string) => {
    setIsOpen(false);
    navigate(path);
  };
  const isActive = (path: string) => location.pathname === path;
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-2' : 'bg-transparent py-4'}`} data-id="element-24">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-25">
        <div className="flex items-center cursor-pointer" onClick={() => goTo('/')} data-id="element-26">
          <Logo data-id="element-27" />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-28">
          <button onClick={() => goTo('/fractional-head-of-ai')} className={`text-text-secondary hover:text-black transition-colors focus:outline-none ${isActive('/fractional-head-of-ai') ? 'text-primary font-semibold border-b-2 border-primary' : ''}`} data-id="element-29">
            Head of AI
          </button>
          <button onClick={() => goTo('/fractional-pm')} className={`text-text-secondary hover:text-black transition-colors focus:outline-none ${isActive('/fractional-pm') ? 'text-primary font-semibold border-b-2 border-primary' : ''}`} data-id="element-30">
            Product Management
          </button>
          <Button onClick={openCalendly} variant="secondary" className="text-xs px-3 py-1.5 focus:outline-none" data-id="element-31">
            Book a consult
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center" data-id="element-32">
          <Button onClick={openCalendly} variant="secondary" className="mr-3 focus:outline-none text-xs px-2 py-1" data-id="element-33">
            Book a consult
          </Button>
          <button className="text-black focus:outline-none p-1 rounded" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} aria-label="Toggle navigation menu" data-id="element-34">
            {isOpen ? <XIcon size={24} data-id="element-35" /> : <MenuIcon size={24} data-id="element-36" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white w-full py-4 px-4 shadow-lg absolute top-full left-0 h-[calc(100vh-80px)] overflow-auto" data-id="element-37">
          <div className="flex flex-col space-y-4" data-id="element-38">
            <button onClick={() => goTo('/')} className={`text-text-secondary hover:text-black transition-colors py-4 text-xl focus:outline-none ${isActive('/') ? 'text-primary font-semibold border-l-4 border-primary pl-2' : ''}`} data-id="element-39">
              Home
            </button>
            <button onClick={() => goTo('/fractional-head-of-ai')} className={`text-text-secondary hover:text-black transition-colors py-4 text-xl focus:outline-none ${isActive('/fractional-head-of-ai') ? 'text-primary font-semibold border-l-4 border-primary pl-2' : ''}`} data-id="element-40">
              Head of AI
            </button>
            <button onClick={() => goTo('/fractional-pm')} className={`text-text-secondary hover:text-black transition-colors py-4 text-xl focus:outline-none ${isActive('/fractional-pm') ? 'text-primary font-semibold border-l-4 border-primary pl-2' : ''}`} data-id="element-41">
              Product Management
            </button>
            <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-42">
              <Button onClick={openCalendly} variant="secondary" className="w-full focus:outline-none text-sm py-2" data-id="element-43">
                Book a consult
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
};